
























helpers = require('../../helpers.coffee')

view_model =
  components:
    colorInput: require('./color_input')

  data: ->
    name: ''
    color: Tag.colors[0]

  methods:
    submit: ->
      @$validator.validateAll({@name}).then (success) =>
        @createTag() if success

    createTag: ->
      Loader.on()
      new TagsResource().create(@createTagSuccess, @handleApiErrors, {@name, @color})

    createTagSuccess: (data) ->
      Loader.off()
      alertify.success 'Salvo com sucesso'
      @$emit('created', data.tag)
      @$store.commit 'addTag', data.tag
      @name = ''
      @color = Tag.colors[0]
      @$nextTick =>
        @errors.clear()

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/tags/new.vue